import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getLicenseFeatureModules} from 'src/openapi/admin/apis/GetLicenseFeatureModulesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLicenseFeatureModules} from './services/dictionary-slice';

export const useLicenseFeatureModules = () => {
    const apiDispatch = useAppDispatch();
    const licenseFeaturesModules = useSelector(selectLicenseFeatureModules);

    const loadLicenseFeaturesModules = useCallback(() => {
        if (!licenseFeaturesModules.length) {
            apiDispatch(getLicenseFeatureModules());
        }
    }, [licenseFeaturesModules.length, apiDispatch]);

    return {licenseFeaturesModules, loadLicenseFeaturesModules};
};
